import { render, staticRenderFns } from "./StepUploadFiles.vue?vue&type=template&id=02ca0200&scoped=true"
import script from "./StepUploadFiles.vue?vue&type=script&lang=js"
export * from "./StepUploadFiles.vue?vue&type=script&lang=js"
import style0 from "./StepUploadFiles.vue?vue&type=style&index=0&id=02ca0200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca0200",
  null
  
)

export default component.exports